import { applyPalette, Toaster, TooltipProvider } from '@bixo/ui'
import { Outlet } from '@tanstack/react-router'
import { useEffect } from 'react'

export function Root() {
  useEffect(() => {
    applyPalette('bixo')
    document.title = 'Bixo Platform'
  }, [])

  return (
    <TooltipProvider delayDuration={300}>
      <Outlet />
      <Toaster />
    </TooltipProvider>
  )
}
